import { USER, USER_PREFERENCES } from "../_constants/actionConstants";
import { BASE_URL } from "../_constants/urlConstants";
import raiseError from "./raiseError";
import axios from "axios";
import raiseWarning from "./raiseWarning";
import getDefaultUserPreferences from "../_helpers/defaultUserPreferences";

const getUserPrefs = (userId) => async (dispatch) => {
  dispatch({ type: USER_PREFERENCES.FETCH });
  const apiEndpoint = `${BASE_URL}/api/Users/${userId}/Preferences`;
  try {
    const res = await axios.get(apiEndpoint);
    const userPreferences = JSON.parse(res.data);
    dispatch({ type: USER_PREFERENCES.FETCH_FULFILLED, userPreferences });
    return;
  } catch (e) {
    raiseError(USER_PREFERENCES.FETCH_REJECTED, e.response.data);
  }
};

const saveUserPrefs = () => async (dispatch, getState) => {
  dispatch({ type: USER_PREFERENCES.SAVE });
  const user = getState().authentication.user;
  if (!user) return;
  const apiEndpoint = `${BASE_URL}/api/Users/${user.userId}/Preferences`;

  const userPref = getState().authentication.user.userPreferences || null;
  if (!userPref) return;

  let userPrefString = "";
  try {
    userPrefString = JSON.stringify(userPref);
  } catch (e) {
    // TODO: log error in backend.
    userPrefString = JSON.stringify(getDefaultUserPreferences());
  }

  try {
    await axios.put(apiEndpoint, { value: userPrefString });
    dispatch({
      type: USER_PREFERENCES.SAVE_FULFILLED,
    });
    return;
  } catch (e) {
    raiseError(USER_PREFERENCES.SAVE_REJECTED, e.response.data);
  }
};

const authenticationActions = {
  getUserPrefs,
  saveUserPrefs,
};

export default authenticationActions;
